<template>
  <button :class="buttonKlass" class="btn rounded-lg px-8 py-4" type="button">
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'StepCategoryBtn',
  props: {
    label: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    buttonKlass() {
      return this.selected ? 'btn-primary' : 'border-neutral-200 hover:border-primary hover:text-primary'
    }
  }
}
</script>

<style lang="scss" scoped>
.btn small {
  display: block;
  color: rgba(0, 0, 0, 0.48);
  font-weight: normal;
  margin-top: 4px;
}

.btn.btn-primary small {
  color: rgba(255, 255, 255, 0.7);
}
</style>
